// extracted by mini-css-extract-plugin
export default {"productGrid":"FZ-z","centerLink":"GZ-z","productSection":"HZ-z","item":"IZ-z","ctaButton":"JZ-z"};